import { gql } from '@apollo/client';

export const ADD_APPROVED_EMAIL = gql`
mutation addApprovedEmail($data: ApprovedEmailInput!) {
    addApprovedEmail(data: $data) {
        status
    }
}
`;
